// extracted by mini-css-extract-plugin
export default {"container":"Experience_container__ITbOk","boxes":"Experience_boxes__P9meJ"};